module.exports = __webpack_public_path__ + "media/images/vp/sample.course-81f152f5f92ee11d5345cc10e4d48c2c.jpg";